<template>
  <div class="cda-content-body" ref="cdaContentBody" :key='getKey' >
    <div class="form-group" v-if="!isCdaSaved">
      <div class="tooltip-wrapper">
        <button class="mr-md-2 mr-2 save-cda btn btn-primary" @click="handleSaveCdaById(cdaId)" ref="saveCdaBtn">Save CDA</button>
      </div>
      <div class="tooltip-wrapper">
        <button class="save-cda btn btn-danger" @click="handleDeleteCdaById(cdaId)" ref="deleteCdaBtn">Delete</button>
      </div>
    </div>

    <button class="btn download-btn" @click="handleDownLoadCda">Download CDA</button>

    <div class="row">
      <cda-doc :cdaDoc="cda" @on-cda-load='onCdaLoad'></cda-doc>
      <cda-content-side-bar 
        :key='getKey2'
        :itemInfo='itemInfo'
        :ready='ready'>
      </cda-content-side-bar>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import CdaDoc from '@/components/includes/cda/CdaDoc';
// import CdaContentSideBar from '@/components/includes/cda/CdaContentSideBar';
import CdaContentSideBar from '@/components/includes/cda/CdaContentSideBarGrouped';
import {
  downloadCdaById,
  deleteCdaById
} from '@/api/cdaApi';
import { CdasNavigation } from '@/store/modules/fsm/messages';
import router from '@/router/index';
import download from 'downloadjs';

export default {
  name: 'cda-content-body',
  components: {
    'cda-doc': CdaDoc,
    'cda-content-side-bar': CdaContentSideBar,
  },
  computed: {
    ready() {
      return this.loaded && this.mounted;
    },
    ...mapGetters('login', {
      user: 'getUser'
    }),
    ...mapGetters('login/cda', {
      cdaList: 'getCdaList',
      cdaIndex: 'getCdaIndex',
      cdaId: 'getCdaId',
      isCdaSaved: 'isCdaSaved',
      indexOfLastCda: 'getIndexOfLastCda'
    }),
    getKey() {
      return 'cda-content-body-'+(this.$route.params.index || 'null');
    },
    getKey2() {
      return 'cda-content-body2-'+(this.$route.params.index || 'null');
    },
    itemInfo() {
      if(this.loaded)
        return { id:this.id,type:this.type };
      else
        return null;
    }
  },
  props:
  {
    index: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: false
    },
    id: {
      type: Number,
      required: false
    },
  },
  data() {
    return {
      cda: '',
      loaded: false,
      mounted: false
    }
  },
  beforeDestroy() {
    delete this.cda;
    this.cda = null;
    this.loaded = false;
    this.mounted = false;
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    onCdaLoad() {
      this.loaded = true;
    },
    ...mapActions('login', [
      'updateApplicationModel'
    ]),
    ...mapActions('login/cda', [
      'requestCdaById',
      'saveCdaById',
      'clearCda'
    ]),
    ...mapActions('login/watch',[
      'setExternalMeasuresLoaded'
    ]),
    handleSaveCdaById(id) {
      this.$swal({
        title: 'Save CDA',
        text: 'Save current CDA to your profile?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Yes, save it',
        reverseButtons: true,
      }).then((result) => {
        if (result.value && !this.isCdaSaved) {
          let loader = this.$loading.show({
            isFullPage: true
          },{
            after: this.$createElement('div',{},['Saving CDA...'])
          });

          this.saveCdaById(id)
          .then(()=>{
            this.$swal({
              type: 'success',
              title: 'CDA saved',
              text: 'CDA is saved to your profile.'
            });
            this.setExternalMeasuresLoaded(false);
          })
          .catch((err) => {
            console.error(err);
            this.$swal({
              type: 'error',
              title: 'Unable to save',
              text: 'Please try again or upload another CDA',
            })
          })
          .finally( () => {
            loader.hide();
            loader = null;
          });
        }
      });
    },
    handleDeleteCdaById(id) {
      let loader;
      this.$swal({
        title: 'Delete CDA',
        text: 'Are you sure  you want to delete this CDA?',
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it',
        reverseButtons: true,
      }).then((result) => {
        if (result.value && !this.isCdaSaved) {
          loader = this.$loading.show({
            container: this.$refs.pageBody
          },{
            after: this.$createElement('div',{},[`Deleting CDA...`])
          });

          deleteCdaById(id)
          .then((response) => {
            if (response.data) {
              // return to get to next then
              return;
            } else {
              this.$swal({
                type: 'error',
                title: 'Error',
                text: 'Cannot delete this CDA',
              });
            }
          })
          .then(() => {
            loader.hide();
            loader = this.$loading.show({
              container: this.$refs.pageBody
            },{
              after: this.$createElement('div',{},[`Updating application data...`])
            });
            return this.updateApplicationModel();
          })
          .then(() => {
            return this.clearCda();
          })
          .then(() => {
            router.push({ name: CdasNavigation });
          })
          .catch((err) => {
            this.$swal({
                type: 'error',
                title: 'Error',
                text: `Cannot delete this CDA. Error: ${err}`,
              });
          })
          .finally(() => {
            loader.hide();
            loader = null;
          });
        }
      });

    },
    handleDownLoadCda() {
      downloadCdaById(this.cdaId)
      .then((response) => {
        download(response.data, `cda_${this.cdaIndex}_${this.user.userName}.xml`, response.headers['content-type']);
      })
      .catch((err) => {
        alert(`Failed to download cda. Reason: ${JSON.stringify(err)}`);
      });
    },
    refresh () {
      if (this.index !== null) {
        if (this.cdaList[this.index] && this.cdaList[this.index].id !== null) {
          // display progress (spinning wheel) as a visual cue
          let loader = this.$loading.show({
            }, {
              after: this.$createElement('div',{},[`Retrieving CDA...`])
            });
          // update cda in iframe
          let id = this.cdaList[this.index].id;
          let index = this.index;
          this.requestCdaById({id, index})
          .then((cdaDoc) => {
            // this change of data will trigger the watcher in cda-doc
            this.cda = cdaDoc;
          })
          .catch((err) => {
            console.error(err);
            this.$swal({
              type: 'error',
              title: `Unable to fetch cda: ${err}`,
              text: 'Please try again',
            })
          }).finally( () => {
            loader.hide();
            loader = null;
          });
        }
        else {
          this.$swal({
            type: 'error',
            title: `Unable to retrieve`,
            text: `The file you requested does not exist. Please choose another file.`
          })
        }
      }
    }
  },
  watch: {
    // refresh div to get cda content when cda index is changed in url
    index (newIndex) {
      this.refresh();
    }
  },
  beforeDestroy() {
    this.clearCda();
  },
  created () {
    this.refresh();
  }
}
</script>

<style scoped lang="scss">
  $delete: #ff4444;
  $delete-hover: #cc0000;
  .download-btn {
    margin-bottom: 1em;
  }
  .btn {
    font-size: 0.9rem;
  }
  input[type="text"] {
    font-size: 0.9rem;
  }

  .tooltip-wrapper {
    display: inline-block;

    .btn[disabled] {
      cursor: not-allowed;
    }
  }

  .hidden {
    display: none;
  }
</style>
